import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/core.scss';
import css from './index.scss';
import Button from '../../button/index';
import { Edit } from '../../../helpers/icon-dictionary';

const EditInfoFormatter = ({ dependentValues, handleOnEdit }) => {
    const id = dependentValues.userProfileId !== undefined ?
        dependentValues.userProfileId :
        dependentValues.classroomId;

    return (
        <Button
            containerClassName={css.editInfo}
            handleOnClick={() => handleOnEdit(id)}
            icon={Edit}
            iconClassName={css.svgIconContainer} />
    );
};

EditInfoFormatter.propTypes = {
    dependentValues: PropTypes.object,
    handleOnEdit: PropTypes.func
};

export default EditInfoFormatter;



// WEBPACK FOOTER //
// ./app/components/formatters/edit-info-formatter/index.js